// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"5fcc8bb0","49":"4e898399","53":"3ebdcc21","96":"53053f48","155":"a7895eef","204":"0516cc29","245":"fd8694ee","357":"c0076cec","453":"9ccb02e9","491":"f6f1ac5e","492":"18ed955a","660":"1dd2a559","824":"f3acf215","883":"603de807"}[chunkId] + ".chunk.js";
};